<template>
  <div class="ml-5 my-3">
    <label-text label="사용자 ID">{{student.userId}}</label-text>
    <label-text label="이름">
      {{student.name}} ({{student.gender}})
      <mdb-btn v-if="isStaff" color="primary" icon="lock" class="ml-4 m-0 p-1" @click="modal=true"> 비밀번호 변경</mdb-btn>
    </label-text>
    <label-text label="성별">{{student.gender}}</label-text>
    <label-text label="email">{{student.email}}</label-text>
    <!-- <label-text label="생년월일">{{birthDate}}</label-text> -->
    <label-text label="상태">{{student.status}}</label-text>
    <label-text label="전화번호">{{cellPhone}}</label-text>
    <label-text label="주소">{{student.address}}</label-text>
    <div>
      <mdb-btn icon="list" @click="$emit('change-mode', 'LIST')"> 돌아가기</mdb-btn>
      <mdb-btn v-if="isStaff" icon="edit" @click="$emit('change-profile')"> 수정</mdb-btn>
      <mdb-btn v-if="isStaff" icon="times" color="danger" @click="$emit('remove', student)"> 삭제</mdb-btn>
    </div>

    <modal-dlg v-if="modal" size="sm" icon="lock" title="비빌번호 변경" :show="modal"  @close="modal=false">
      <div>
        <mdb-input type="password" label="새 비밀번호" v-model="newPassword"/>
        <mdb-input type="password" label="새 비밀번호 확인" v-model="newPassword2"/>
      </div>
      <div class="text-center">
        <mdb-btn class="py-2 mr-3" color="primary" @click="onChangePassword">변경</mdb-btn>
        <mdb-btn class="py-2" @click="modal=false">닫기</mdb-btn>
      </div>
    </modal-dlg>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import LabelText from '../common/LabelText.vue';
import ModalDlg from '../common/ModalDlg.vue';
export default {
  name: 'Student',
  components: { LabelText, ModalDlg },
  props: ['student'],
  data: () => ({
    labelWidth: '100px',
    modal: false,
    newPassword: '',
    newPassword2: ''
  }),
  computed: {
    ...mapGetters('auth', ['isStaff']),
    cellPhone () {
      const ph = this.student.cellPhone
      return ph.number1 + '-' + ph.number2 + '-' + ph.number3;
    },
    birthDate () {
      if (!this.student.birthDate) return ''
      const birth = this.student.birthDate
      return birth.year + '-' + ('00' + birth.month).slice(-2) + '-' + ('00' + birth.date).slice(-2);
    }
  },
  methods: {
    ...mapMutations([]),
    ...mapActions('auth', ['changePasswordByStaff']),
    async onChangePassword () {
      if (this.newPassword !== this.newPassword2) {
        alert('비밀번호 확인이 다릅니다.')
        return
      }
      await this.changePasswordByStaff({
        _id: this.student._id,
        newPassword: this.newPassword
      })
      this.modal = false
      alert('비밀번호가 변경되었습니다.')
      this.newPassword = ''
      this.newPassword2 = ''
    }
  }
}
</script>
